var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roam"},[_c('img',{staticClass:"img1",attrs:{"src":require("../assets/images/items/item2/quit.png"),"alt":""},on:{"click":_vm.goAbout}}),_c('iframe',{ref:"iframe",attrs:{"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }